import * as _ from 'lodash';

export type StateName =
  | 'LOGIN'
  | 'REQUEST_RESET_PASSWORD'
  | 'CHOOSE_RESET_PASSWORD'
  | 'REQUEST_RESET_DORMANCY'
  | 'SIGNUP'
  | 'JOURNEY'
  | 'SHORT_FORM'
  | 'UPFRONT_RATES'
  | 'MILESTONES'
  | 'CREATE_ACCOUNT'
  | 'REVIEW_DOCUMENTS_COMPLETED'
  | 'CHOOSE_LOAN_TYPE'
  | 'ACTIVATION_PASSWORD_BORROWER'
  | 'REVIEW_DOCUMENTS'
  | 'PROVIDE_ECONSENT'
  | 'LOAN_ESTIMATE_EXPLANATION'
  | 'LOAN_ESTIMATE'
  | 'LOAN_ESTIMATE_TERMS'
  | 'LOAN_ESTIMATE_RECEIVED'
  | 'ACTIVATION_EXPIRED'
  | 'RESENT_ACTIVATION'
  | 'LOGOUT'
  | 'INTERIM_SSO_TERMS'
  | 'FAST_FORWARD'
  | 'ACCEPT_TERMS'
  | 'JOURNEY_CHOOSER'
  | 'PROVIDE_PHONE_NUMBER'
  | 'VIEW_TERMS'
  | 'VIEW_ECONSENT'
  | 'VIEW_PRIVACY_POLICY'
  | 'ONE_TAP_LOADING'
  | 'LOAN_HYDRATION'
  | 'LENDER_LOGIN_EMAIL_ONLY'
  | 'LENDER_LOGIN_PASSWORD_ONLY'
  | 'ACTIVATION_PASSWORD_LENDER'
  | 'LENDER_OAUTH'
  | 'LENDER_MFA_SETUP'
  | 'LENDER_MFA_VALIDATE'
  | 'LENDER_MFA_VERIFY'
  | 'ACCOUNT_OPENING'
  | 'AUTO_LOAN'
  | 'AUTO_PURCHASE_TYPE'
  | 'AUTO_REFINANCE_TYPE'
  | 'LOAN_OFFICER'
  | 'LICENSING_INFORMATION'
  | 'CHOOSE_APPLICATION';

type StateMap = Record<StateName, RouteState>;

export const StatesRich: StateMap = {
  LOGIN: {
    path: '',
    name: 'LOGIN',
  },
  REQUEST_RESET_PASSWORD: {
    path: 'reset-password',
    name: 'REQUEST_RESET_PASSWORD',
  },
  CHOOSE_RESET_PASSWORD: {
    path: 'choose-reset-password',
    name: 'CHOOSE_RESET_PASSWORD',
  },
  REQUEST_RESET_DORMANCY: {
    path: 'reset-dormancy',
    name: 'REQUEST_RESET_DORMANCY',
  },
  SIGNUP: {
    path: 'signup',
    name: 'SIGNUP',
  },
  JOURNEY: {
    path: 'journey',
    name: 'JOURNEY',
  },
  SHORT_FORM: {
    path: 'short-form',
    name: 'SHORT_FORM',
  },
  UPFRONT_RATES: {
    path: 'upfront-rates',
    name: 'UPFRONT_RATES',
  },
  MILESTONES: {
    path: 'milestones',
    name: 'MILESTONES',
  },
  CREATE_ACCOUNT: {
    path: 'create-account',
    name: 'CREATE_ACCOUNT',
  },
  REVIEW_DOCUMENTS_COMPLETED: {
    path: 'review-documents-completed',
    name: 'REVIEW_DOCUMENTS_COMPLETED',
  },
  CHOOSE_LOAN_TYPE: {
    path: 'choose-loan-type',
    name: 'CHOOSE_LOAN_TYPE',
  },
  ACTIVATION_PASSWORD_BORROWER: {
    path: 'activation-borrower',
    name: 'ACTIVATION_PASSWORD_BORROWER',
  },
  REVIEW_DOCUMENTS: {
    path: 'review-documents',
    name: 'REVIEW_DOCUMENTS',
  },
  PROVIDE_ECONSENT: {
    path: 'provide-econsent',
    name: 'PROVIDE_ECONSENT',
  },
  LOAN_ESTIMATE_EXPLANATION: {
    path: 'estimate-explanation',
    name: 'LOAN_ESTIMATE_EXPLANATION',
  },
  LOAN_ESTIMATE: {
    path: 'loan-estimate',
    name: 'LOAN_ESTIMATE',
  },
  LOAN_ESTIMATE_TERMS: {
    path: 'loan-estimate-terms',
    name: 'LOAN_ESTIMATE_TERMS',
  },
  LOAN_ESTIMATE_RECEIVED: {
    path: 'loan-estimate-received',
    name: 'LOAN_ESTIMATE_RECEIVED',
  },
  ACTIVATION_EXPIRED: {
    path: 'expired',
    name: 'ACTIVATION_EXPIRED',
  },
  RESENT_ACTIVATION: {
    path: 'resent-activation',
    name: 'RESENT_ACTIVATION',
  },
  LOGOUT: {
    path: 'logout',
    name: 'LOGOUT',
  },
  INTERIM_SSO_TERMS: {
    path: 'public-terms',
    name: 'INTERIM_SSO_TERMS',
  },

  FAST_FORWARD: {
    path: 'fast-forward',
    name: 'FAST_FORWARD',
  },
  ACCEPT_TERMS: {
    path: 'accept-terms',
    name: 'ACCEPT_TERMS',
  },
  JOURNEY_CHOOSER: {
    path: 'journey-chooser',
    name: 'JOURNEY_CHOOSER',
  },
  PROVIDE_PHONE_NUMBER: {
    path: 'provide-phone-number',
    name: 'PROVIDE_PHONE_NUMBER',
  },
  VIEW_TERMS: {
    path: 'terms-of-use',
    name: 'VIEW_TERMS',
  },
  VIEW_ECONSENT: {
    path: 'e-consent',
    name: 'VIEW_ECONSENT',
  },
  VIEW_PRIVACY_POLICY: {
    path: 'privacy-policy',
    name: 'VIEW_PRIVACY_POLICY',
  },
  ONE_TAP_LOADING: {
    path: 'loading',
    name: 'ONE_TAP_LOADING',
  },
  LOAN_HYDRATION: {
    path: 'loading-loan',
    name: 'LOAN_HYDRATION',
  },
  // Lender actions
  LENDER_LOGIN_EMAIL_ONLY: {
    path: 'login',
    name: 'LENDER_LOGIN_EMAIL_ONLY',
  },
  LENDER_LOGIN_PASSWORD_ONLY: {
    path: 'login-password',
    name: 'LENDER_LOGIN_PASSWORD_ONLY',
  },
  // TODO (DSP-15179): Rename/remove differences between these two states. This is annoying.
  ACTIVATION_PASSWORD_LENDER: {
    path: 'activation',
    name: 'ACTIVATION_PASSWORD_LENDER',
  },
  LENDER_OAUTH: {
    path: 'authorize',
    name: 'LENDER_OAUTH',
  },
  LENDER_MFA_SETUP: {
    path: 'setup/mfa/new',
    name: 'LENDER_MFA_SETUP',
  },
  LENDER_MFA_VALIDATE: {
    path: 'setup/mfa/validate',
    name: 'LENDER_MFA_VALIDATE',
  },
  LENDER_MFA_VERIFY: {
    path: 'mfa',
    name: 'LENDER_MFA_VERIFY',
  },

  ACCOUNT_OPENING: {
    path: 'account-opening',
    name: 'ACCOUNT_OPENING',
  },

  AUTO_LOAN: {
    path: 'auto-loan',
    name: 'AUTO_LOAN',
  },
  AUTO_PURCHASE_TYPE: {
    path: 'auto-purchase-type',
    name: 'AUTO_PURCHASE_TYPE',
  },
  AUTO_REFINANCE_TYPE: {
    path: 'auto-refinance-type',
    name: 'AUTO_REFINANCE_TYPE',
  },

  LOAN_OFFICER: {
    path: 'loan-officers/:loIdentifier',
    name: 'LOAN_OFFICER',
  },

  LICENSING_INFORMATION: {
    path: 'licensing-information',
    name: 'LICENSING_INFORMATION',
  },

  CHOOSE_APPLICATION: {
    path: 'choose-application',
    name: 'CHOOSE_APPLICATION',
  },
};

export function isState(path: string, stateName: string) {
  return path === `/${stateName}`;
}

const States = Object.freeze(_.transform<RouteState, any>(StatesRich, (acc, v, k: string) => (acc[k] = v.path), {}));
export default States;
